/**
 * Consent Activation Page - JavaScript
 *
 * Reads configuration from #ca-config element data attributes:
 *   data-api-url    : Consent API base URL (e.g. https://como-passport.cmfc-tech.com)
 *   data-api-key    : API key for X-API-Key header
 *   data-shop-id    : Shopify shop permanent domain
 *   data-test-mode  : "true" / "false"
 *   data-locale     : Locale ISO code (e.g. "it", "en")
 */
(function () {
  'use strict';

  /* ------------------------------------------
     CONFIGURATION (from data attributes)
     ------------------------------------------ */
  var configEl = document.getElementById('ca-config');
  if (!configEl) {
    console.warn('[ConsentActivation] #ca-config not found, aborting.');
    return;
  }
  console.log('[ConsentActivation] Script loaded, configEl found.');

  var API_URL = configEl.getAttribute('data-api-url') || 'https://como-passport.cmfc-tech.com';
  var API_KEY = configEl.getAttribute('data-api-key') || '';
  var SHOP_ID = configEl.getAttribute('data-shop-id') || '';
  var TEST_MODE = configEl.getAttribute('data-test-mode') === 'true';
  var LOCALE = configEl.getAttribute('data-locale') || 'en';

  /* ------------------------------------------
     STORE AUTH GATE
     ------------------------------------------ */
  var storeAuthGate = document.getElementById('ca-store-auth-gate');
  var mainContent = document.getElementById('ca-main-content');
  var storeLoginBtn = document.getElementById('ca-store-login-btn');
  var storeIdInput = document.getElementById('ca-store-id');
  var storePwInput = document.getElementById('ca-store-password');
  var storeAuthError = document.getElementById('ca-store-auth-error');
  var storeSessionBar = document.getElementById('ca-store-session-bar');
  var storeSessionName = document.getElementById('ca-store-session-name');
  var storeLogoutBtn = document.getElementById('ca-store-logout-btn');

  var storeSession = {
    token: sessionStorage.getItem('ca_store_token') || '',
    store_id: sessionStorage.getItem('ca_store_id') || '',
    store_name: sessionStorage.getItem('ca_store_name') || '',
    expires_at: sessionStorage.getItem('ca_store_expires') || '',
  };

  function showStoreAuthError(msg) {
    if (storeAuthError) {
      storeAuthError.textContent = msg;
      storeAuthError.classList.add('is-visible');
    }
  }

  function hideStoreAuthError() {
    if (storeAuthError) {
      storeAuthError.textContent = '';
      storeAuthError.classList.remove('is-visible');
    }
  }

  function activateMainContent() {
    if (storeAuthGate) storeAuthGate.style.display = 'none';
    if (mainContent) mainContent.style.display = '';
    if (storeSessionBar && storeSession.store_name) {
      storeSessionName.textContent = storeSession.store_name;
      storeSessionBar.style.display = '';
    }
    window.scrollTo({ top: 0 });
  }

  function deactivateMainContent() {
    if (storeAuthGate) storeAuthGate.style.display = 'block';
    if (mainContent) mainContent.style.display = 'none';
    window.scrollTo({ top: 0 });
    if (storeSessionBar) storeSessionBar.style.display = 'none';
    storeSession = { token: '', store_id: '', store_name: '', expires_at: '' };
    sessionStorage.removeItem('ca_store_token');
    sessionStorage.removeItem('ca_store_id');
    sessionStorage.removeItem('ca_store_name');
    sessionStorage.removeItem('ca_store_expires');
  }

  function validateStoreSession() {
    if (!storeSession.token) {
      console.log('[StoreAuth] No token in sessionStorage, showing login.');
      deactivateMainContent();
      return;
    }

    console.log('[StoreAuth] Validating session token...');
    fetch(API_URL + '/api/store-auth/session', {
      method: 'GET',
      headers: { 'X-Store-Token': storeSession.token },
    })
      .then(function (res) {
        console.log('[StoreAuth] Session response status:', res.status);
        return res.json();
      })
      .then(function (data) {
        console.log('[StoreAuth] Session response data:', data);
        if (data.success) {
          storeSession.store_name = data.store_name;
          storeSession.store_id = data.store_id;
          activateMainContent();
        } else {
          console.warn('[StoreAuth] Session invalid, re-login required.');
          deactivateMainContent();
        }
      })
      .catch(function (err) {
        console.error('[StoreAuth] Session validation failed:', err);
        deactivateMainContent();
      });
  }

  if (storeLoginBtn) {
    storeLoginBtn.addEventListener('click', function () {
      hideStoreAuthError();
      var sid = storeIdInput ? storeIdInput.value.trim() : '';
      var pw = storePwInput ? storePwInput.value : '';

      if (!sid || !pw) {
        showStoreAuthError(LOCALE === 'it' ? 'Inserisci Store ID e password.' : 'Please enter Store ID and password.');
        return;
      }

      storeLoginBtn.classList.add('is-loading');

      fetch(API_URL + '/api/store-auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ store_id: sid, password: pw }),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          storeLoginBtn.classList.remove('is-loading');
          if (data.success) {
            storeSession.token = data.session_token;
            storeSession.store_id = data.store_id;
            storeSession.store_name = data.store_name;
            storeSession.expires_at = data.expires_at;
            sessionStorage.setItem('ca_store_token', data.session_token);
            sessionStorage.setItem('ca_store_id', data.store_id);
            sessionStorage.setItem('ca_store_name', data.store_name);
            sessionStorage.setItem('ca_store_expires', data.expires_at);
            activateMainContent();
          } else {
            showStoreAuthError(data.error || (LOCALE === 'it' ? 'Credenziali non valide.' : 'Invalid credentials.'));
          }
        })
        .catch(function () {
          storeLoginBtn.classList.remove('is-loading');
          showStoreAuthError(LOCALE === 'it' ? 'Errore di connessione.' : 'Connection error.');
        });
    });

    if (storePwInput) {
      storePwInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') storeLoginBtn.click();
      });
    }
  }

  if (storeLogoutBtn) {
    storeLogoutBtn.addEventListener('click', function () {
      if (storeSession.token) {
        fetch(API_URL + '/api/store-auth/logout', {
          method: 'POST',
          headers: { 'X-Store-Token': storeSession.token },
        }).catch(function () {});
      }
      deactivateMainContent();
    });
  }

  validateStoreSession();

  var MSG =
    LOCALE === 'it'
      ? {
          checking: 'Verifica in corso...',
          found: 'Account trovato',
          not_found: 'Utente non trovato',
          updated: 'Consensi aggiornati con successo!',
          update_err: 'Si è verificato un errore. Riprova.',
          no_new: 'Nessun nuovo consenso selezionato.',
          invalid_email: 'Inserisci un indirizzo email valido.',
          already_registered: ' L’utente è già registrato al Programma Como Passport.',
          passport_activated: 'ComoPassport attivato con successo!',
          check_email: 'Email di verifica inviata! Controlla la tua casella di posta per confermare.',
        }
      : {
          checking: 'Checking...',
          found: 'Account found',
          not_found: 'User not found',
          updated: 'Consents updated successfully!',
          update_err: 'An error occurred. Please try again.',
          no_new: 'No new consents selected.',
          invalid_email: 'Please enter a valid email address.',
          already_registered: 'The user is already registered in the Como Passport Program.',
          passport_activated: 'ComoPassport activated successfully!',
          check_email: 'Verification email sent! Please check your inbox to confirm.',
        };

  // Track apakah customer sudah punya ComoPassport
  var hasComoPassport = false;

  /* ------------------------------------------
     COMMON FETCH HELPER
     ------------------------------------------ */
  function apiFetch(endpoint, options) {
    options = options || {};
    options.headers = options.headers || {};
    options.headers['X-API-Key'] = API_KEY;
    if (storeSession.token) {
      options.headers['X-Store-Token'] = storeSession.token;
    }
    if (!options.headers['Accept']) {
      options.headers['Accept'] = 'application/json';
    }
    return fetch(API_URL + endpoint, options);
  }

  /* ------------------------------------------
     DOM REFERENCES
     ------------------------------------------ */
  var emailInput = document.getElementById('ca-email-input');
  var emailMsg = document.getElementById('ca-email-msg');
  var checkBtn = document.getElementById('ca-check-btn');
  var sectionNew = document.getElementById('ca-section-new');
  var sectionExist = document.getElementById('ca-section-existing');
  var hiddenEmail = document.getElementById('ca-hidden-email');
  var hiddenMktg = document.getElementById('ca-hidden-marketing');
  var updateBtn = document.getElementById('ca-update-btn');
  var resultMsg = document.getElementById('ca-result-msg');
  var resultText = document.getElementById('ca-result-text');

  // Password method elements
  var passwordMethodWrap = document.getElementById('ca-password-method');
  var passwordFieldWrap = document.getElementById('ca-password-field-wrap');
  var passwordEmailInfo = document.getElementById('ca-password-email-info');
  var passwordInput = document.getElementById('CA-Password');
  var passwordMethod = 'now'; // 'now' or 'email'

  /* ------------------------------------------
     HELPERS
     ------------------------------------------ */
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function resetAll() {
    emailMsg.className = 'ca-email-msg';
    emailMsg.textContent = '';

    // Clean up email-sent overlays and restore hidden children
    [sectionNew, sectionExist].forEach(function (section) {
      var overlay = section.querySelector('.ca-email-sent');
      if (overlay) overlay.remove();
      Array.from(section.children).forEach(function (child) {
        child.style.display = '';
      });
      section.style.display = 'none';
      section.classList.remove('is-visible');
    });

    // Restore elements that may have been hidden by onCustomerFound
    var existingCheckboxes = document.getElementById('ca-existing-checkboxes');
    if (existingCheckboxes) existingCheckboxes.style.display = '';
    var consentStatement = sectionExist.querySelector('.register-form__consent-statement');
    if (consentStatement) consentStatement.style.display = '';
    var nameFields = sectionExist.querySelector('.ca-name-fields');
    if (nameFields) nameFields.style.display = '';
    if (updateBtn) updateBtn.style.display = '';
    var backHomeBtn = document.getElementById('ca-back-home-btn');
    if (backHomeBtn) backHomeBtn.style.display = 'none';

    // Restore original "Account found" wording
    var foundText = sectionExist.querySelector('.ca-found-text p');
    if (foundText) {
      foundText.textContent = LOCALE === 'it'
        ? 'Seleziona i consensi aggiuntivi che desideri attivare per il tuo Como Passport.'
        : 'Select any additional consents you would like to activate for your Como Passport.';
    }

    resultMsg.classList.remove('is-visible', 'is-success', 'is-error');

    var newRequiredCb = document.getElementById('ca-new-required-cb');
    if (newRequiredCb) {
      newRequiredCb.checked = false;
      var newRequiredSpan = newRequiredCb.nextElementSibling;
      if (newRequiredSpan) newRequiredSpan.classList.remove('checked');
    }
    var existRequiredCb = document.getElementById('ca-exist-required-cb');
    if (existRequiredCb) {
      existRequiredCb.checked = false;
      var existRequiredSpan = existRequiredCb.nextElementSibling;
      if (existRequiredSpan) existRequiredSpan.classList.remove('checked');
    }
    updateSubmitState();
  }

  function showSection(el) {
    el.style.display = 'block';
    void el.offsetWidth; // trigger reflow for animation
    el.classList.add('is-visible');
  }

  function generateRandomPassword(len) {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@#$%';
    var pw = '';
    for (var i = 0; i < (len || 24); i++) {
      pw += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return pw;
  }

  /* ------------------------------------------
     PASSWORD METHOD TOGGLE
     ------------------------------------------ */
  if (passwordMethodWrap) {
    var pwRadios = passwordMethodWrap.querySelectorAll('input[name="ca_password_method"]');
    pwRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        passwordMethod = this.value;

        passwordMethodWrap.querySelectorAll('.ca-password-option').forEach(function (o) {
          o.classList.remove('is-active');
        });
        this.closest('.ca-password-option').classList.add('is-active');

        if (passwordMethod === 'now') {
          if (passwordFieldWrap) passwordFieldWrap.classList.remove('is-hidden');
          if (passwordInput) {
            passwordInput.required = true;
            passwordInput.value = '';
          }
          if (passwordEmailInfo) {
            passwordEmailInfo.classList.remove('is-visible');
            setTimeout(function () { passwordEmailInfo.style.display = 'none'; }, 300);
          }
        } else {
          if (passwordFieldWrap) passwordFieldWrap.classList.add('is-hidden');
          if (passwordInput) {
            passwordInput.required = false;
          }
          if (passwordEmailInfo) {
            passwordEmailInfo.style.display = 'flex';
            void passwordEmailInfo.offsetWidth;
            passwordEmailInfo.classList.add('is-visible');
          }
        }
      });
    });
  }

  /* ------------------------------------------
     CHECK BUTTON CLICK HANDLER
     ------------------------------------------ */
  console.log('[ConsentActivation] checkBtn:', checkBtn, '| emailInput:', emailInput, '| emailMsg:', emailMsg);

  if (checkBtn) {
    checkBtn.addEventListener('click', function () {
      console.log('[ConsentActivation] Check button clicked!');
      resetAll();

      var email = emailInput.value.trim();
      console.log('[ConsentActivation] Email value:', email, '| Valid:', isValidEmail(email));

      if (!email || !isValidEmail(email)) {
        emailMsg.className = 'ca-email-msg is-error';
        emailMsg.textContent = MSG.invalid_email;
        console.log('[ConsentActivation] Invalid email, showing message.');
        return;
      }

      checkBtn.classList.add('is-loading');
      console.log('[ConsentActivation] Calling checkCustomer, TEST_MODE:', TEST_MODE);
      checkCustomer(email);
    });
  } else {
    console.warn('[ConsentActivation] #ca-check-btn NOT found in DOM!');
  }

  /* ------------------------------------------
     CHECK CUSTOMER (via our Consent API)
     ------------------------------------------ */
  function checkCustomer(email) {
    if (TEST_MODE) {
      setTimeout(function () {
        checkBtn.classList.remove('is-loading');
        var lowerEmail = email.toLowerCase();
        if (lowerEmail.indexOf('new') !== -1 || lowerEmail.indexOf('register') !== -1) {
          onCustomerNotFound(email);
        } else {
          onCustomerFound(email, [
            { tag: 'ComoPassport', granted_at: new Date().toISOString() },
            { tag: 'newsletter', granted_at: new Date().toISOString() },
          ], [], 'Test', 'User');
        }
      }, 1000);
      return;
    }

    apiFetch(
      '/api/consent/check-email?email=' +
        encodeURIComponent(email) +
        '&shop_id=' +
        encodeURIComponent(SHOP_ID),
      { method: 'GET' }
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        checkBtn.classList.remove('is-loading');
        if (data.exists) {
          onCustomerFound(email, data.consents || [], data.pendingConsents || [], data.firstName || '', data.lastName || '');
        } else {
          onCustomerNotFound(email);
        }
      })
      .catch(function (err) {
        checkBtn.classList.remove('is-loading');
        console.error('[ConsentAPI] Check email error:', err);
        onCustomerNotFound(email);
      });
  }

  /* ------------------------------------------
     CUSTOMER FOUND → show existing section
     consents:        [{ tag, granted_at }]  — confirmed
     pendingConsents: ['tag1','tag2']         — awaiting email verification
     firstName/lastName: from Shopify customer data
     ------------------------------------------ */
  function onCustomerFound(email, consents, pendingConsents, firstName, lastName) {
    emailMsg.className = 'ca-email-msg';
    emailMsg.textContent = '';

    // Autofill name fields (disabled, info only)
    var fnInput = document.getElementById('ca-exist-firstname');
    var lnInput = document.getElementById('ca-exist-lastname');
    if (fnInput) {
      fnInput.value = firstName || '';
      fnInput.disabled = true;
    }
    if (lnInput) {
      lnInput.value = lastName || '';
      lnInput.disabled = true;
    }

    // Build sets of confirmed and pending tags
    var confirmedTags = consents.map(function (c) { return c.tag; });
    var pendingTags = pendingConsents || [];

    // Track apakah sudah punya ComoPassport (hanya confirmed — sudah verifikasi email)
    hasComoPassport = confirmedTags.indexOf('ComoPassport') !== -1;

    var existingCheckboxes = document.getElementById('ca-existing-checkboxes');
    var consentStatement = sectionExist.querySelector('.register-form__consent-statement');
    var foundText = sectionExist.querySelector('.ca-found-text p');

    var nameFields = sectionExist.querySelector('.ca-name-fields');

    var backHomeBtn = document.getElementById('ca-back-home-btn');

    if (hasComoPassport) {
      // Has ComoPassport — hide name fields, consent box, submit; show back to home
      if (nameFields) nameFields.style.display = 'none';
      if (consentStatement) consentStatement.style.display = 'none';
      if (updateBtn) updateBtn.style.display = 'none';
      if (backHomeBtn) { backHomeBtn.style.display = 'block'; backHomeBtn.style.margin = '0 auto'; }
      if (foundText) {
        foundText.textContent = LOCALE === 'it'
          ? 'Questo account è già registrato a ComoPassport.'
          : 'This account is already registered to ComoPassport.';
      }
    } else {
      // No ComoPassport — show full consent flow with checkboxes
      if (nameFields) nameFields.style.display = '';
      if (consentStatement) consentStatement.style.display = '';
      if (existingCheckboxes) existingCheckboxes.style.display = '';
      if (updateBtn) updateBtn.style.display = '';
      if (backHomeBtn) backHomeBtn.style.display = 'none';
      if (foundText) {
        foundText.textContent = LOCALE === 'it'
          ? 'Seleziona i consensi aggiuntivi che desideri attivare per il tuo Como Passport.'
          : 'Select any additional consents you would like to activate for your Como Passport.';
      }

      var checkboxes = document.querySelectorAll('#ca-existing-checkboxes .ca-ecb');
      checkboxes.forEach(function (cb) {
        var tag = cb.getAttribute('data-tag');
        var holder = cb.closest('.register-form__holder');
        var spanEl = cb.nextElementSibling;

        if (confirmedTags.indexOf(tag) !== -1) {
          cb.checked = true;
          cb.disabled = true;
          holder.classList.add('is-existing');
          if (spanEl) spanEl.classList.add('checked');
        } else if (pendingTags.indexOf(tag) !== -1) {
          cb.checked = true;
          cb.disabled = true;
          holder.classList.add('is-existing', 'is-pending');
          if (spanEl) spanEl.classList.add('checked');
        } else {
          cb.checked = false;
          cb.disabled = false;
          holder.classList.remove('is-existing', 'is-pending');
          if (spanEl) spanEl.classList.remove('checked');
        }
      });

      var existRequiredCb = document.getElementById('ca-exist-required-cb');
      if (existRequiredCb) {
        existRequiredCb.checked = false;
        var existRequiredSpan = existRequiredCb.nextElementSibling;
        if (existRequiredSpan) existRequiredSpan.classList.remove('checked');
      }
      updateSubmitState();
    }

    showSection(sectionExist);
  }

  /* ------------------------------------------
     CUSTOMER NOT FOUND → show new form
     ------------------------------------------ */
  function onCustomerNotFound(email) {
    emailMsg.className = 'ca-email-msg';
    emailMsg.textContent = '';

    if (hiddenEmail) hiddenEmail.value = email;

    showSection(sectionNew);
  }

  /* ------------------------------------------
     CHECKBOX CLICK HANDLERS
     ------------------------------------------ */
  function updateSubmitState() {
    var newRequiredCb = document.getElementById('ca-new-required-cb');
    var newSubmitBtn = document.getElementById('ca-new-submit');
    if (newRequiredCb && newSubmitBtn) {
      var newEnabled = newRequiredCb.checked;
      newSubmitBtn.disabled = !newEnabled;
      if (newEnabled) {
        newSubmitBtn.classList.remove('is-disabled');
      } else {
        newSubmitBtn.classList.add('is-disabled');
      }
    }

    var existRequiredCb = document.getElementById('ca-exist-required-cb');
    if (existRequiredCb && updateBtn) {
      var existEnabled = existRequiredCb.checked;
      updateBtn.disabled = !existEnabled;
      if (existEnabled) {
        updateBtn.classList.remove('is-disabled');
      } else {
        updateBtn.classList.add('is-disabled');
      }
    }
  }

  function setupCheckboxes(container) {
    if (!container) return;
    var holders = container.querySelectorAll('.register-form__holder');
    holders.forEach(function (holder) {
      var spans = holder.querySelectorAll(
        '.register-form__agreement-input-required,' +
          '.register-form__agreement-input-option,' +
          '.register-form__agreement-input-thirdparty'
      );
      spans.forEach(function (span) {
        span.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('a')) return;
          e.preventDefault();
          e.stopPropagation();
          var cb = holder.querySelector('input[type="checkbox"]');
          if (cb.disabled) return;
          cb.checked = !cb.checked;
          toggleSpan(cb);
          updateSubmitState();
        });
      });

      holder.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a')) return;
        e.preventDefault(); // Prevent <label> default toggling the checkbox
        if (e.target.tagName === 'INPUT') return;
        var cb = holder.querySelector('input[type="checkbox"]');
        if (cb.disabled) return;
        cb.checked = !cb.checked;
        toggleSpan(cb);
        updateSubmitState();
      });
    });
  }

  function toggleSpan(cb) {
    var span = cb.nextElementSibling;
    if (span) {
      if (cb.checked) {
        span.classList.add('checked');
      } else {
        span.classList.remove('checked');
      }
    }
  }

  /* ------------------------------------------
     NEW CUSTOMER FORM SUBMIT
     Customer creation is handled entirely by backend via Shopify Admin API.
     No native Shopify form submission needed.
     ------------------------------------------ */
  var newForm = document.getElementById('ca-new-form');
  if (newForm) {
    // Remove native action to prevent any accidental Shopify form submission
    newForm.removeAttribute('action');
    newForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var newRequiredCb = document.getElementById('ca-new-required-cb');
      if (!newRequiredCb || !newRequiredCb.checked) {
        return;
      }

      var tags = ['ComoPassport'];
      var marketing = false;

      sectionNew.querySelectorAll('.ca-cb').forEach(function (cb) {
        if (cb.checked) {
          tags.push(cb.getAttribute('data-tag'));
          if (cb.getAttribute('data-marketing') === 'true') marketing = true;
        }
      });

      var submitBtn = document.getElementById('ca-new-submit');
      if (submitBtn) submitBtn.classList.add('is-loading');

      var email = hiddenEmail ? hiddenEmail.value.trim() : '';

      var caFirstName = document.getElementById('CA-FirstName');
      var caLastName = document.getElementById('CA-LastName');

      // Read password directly from the checked radio method
      var currentPwMethod = passwordMethod;
      var checkedRadio = document.querySelector('input[name="ca_password_method"]:checked');
      if (checkedRadio) currentPwMethod = checkedRadio.value;

      var customerPassword = '';
      if (currentPwMethod === 'now' && passwordInput) {
        customerPassword = passwordInput.value;
      }

      if (email && API_URL && API_KEY) {
        var registerBody = {
          shop_id: SHOP_ID,
          email: email,
          tags: tags,
          first_name: caFirstName ? caFirstName.value.trim() : '',
          last_name: caLastName ? caLastName.value.trim() : '',
          source: 'consent_activation',
          locale: LOCALE,
          password_method: currentPwMethod,
          password: customerPassword,
          accepts_marketing: marketing,
        };
        if (storeSession.store_id) {
          registerBody.registered_by_store_id = storeSession.store_id;
        }

        apiFetch('/api/consent/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(registerBody),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { status: res.status, ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            if (submitBtn) submitBtn.classList.remove('is-loading');
            if (!result.ok) {
              console.error('[ConsentAPI] Register failed:', result.status, result.data);
              showResult('error', result.data.error || 'Registration failed. Please try again.');
              return;
            }
            showEmailSentState(sectionNew, result.data.message || MSG.check_email, email);
          })
          .catch(function (err) {
            if (submitBtn) submitBtn.classList.remove('is-loading');
            console.error('[ConsentAPI] Register error:', err);
            showResult('error', 'Connection error. Please try again.');
          });
      }
    });
  }

  /* ------------------------------------------
     EXISTING CUSTOMER: SUBMIT CONSENT UPDATE
     ------------------------------------------ */
  function lockNewlyChecked() {
    document.querySelectorAll('#ca-existing-checkboxes .ca-ecb').forEach(function (cb) {
      if (cb.checked && !cb.disabled) {
        cb.disabled = true;
        var holder = cb.closest('.register-form__holder');
        holder.classList.add('is-existing');
        var badge = holder.querySelector('.ca-tag-badge');
        if (badge) badge.style.display = 'inline-block';
      }
    });
  }

  if (updateBtn) {
    updateBtn.addEventListener('click', function () {
      var existRequiredCb = document.getElementById('ca-exist-required-cb');
      if (!existRequiredCb || !existRequiredCb.checked) {
        return;
      }

      var email = emailInput.value.trim();

      // Collect only newly-checked (not disabled) tags
      var newTags = [];
      document.querySelectorAll('#ca-existing-checkboxes .ca-ecb').forEach(function (cb) {
        if (cb.checked && !cb.disabled) {
          newTags.push(cb.getAttribute('data-tag'));
        }
      });

      // Jika tidak ada consent baru yang diceklis
      if (newTags.length === 0) {
        // Sudah punya ComoPassport → sudah terdaftar
        if (hasComoPassport) {
          showResult('success', MSG.already_registered);
          return;
        }
        // Belum punya ComoPassport → auto push ComoPassport
        newTags.push('ComoPassport');
      }

      // Selalu pastikan ComoPassport ada di tags yang dikirim
      if (newTags.indexOf('ComoPassport') === -1 && !hasComoPassport) {
        newTags.unshift('ComoPassport');
      }

      updateBtn.classList.add('is-loading');
      resultMsg.classList.remove('is-visible', 'is-success', 'is-error');

      if (TEST_MODE) {
        setTimeout(function () {
          updateBtn.classList.remove('is-loading');
          lockNewlyChecked();
          hasComoPassport = true;
          showEmailSentState(sectionExist, MSG.check_email, email);
        }, 1200);
        return;
      }

      // Get name from autofilled fields
      var existFn = document.getElementById('ca-exist-firstname');
      var existLn = document.getElementById('ca-exist-lastname');

      var updateBody = {
        shop_id: SHOP_ID,
        email: email,
        tags: newTags,
        first_name: existFn ? existFn.value.trim() : '',
        last_name: existLn ? existLn.value.trim() : '',
        source: 'consent_activation',
        locale: LOCALE,
      };
      if (storeSession.store_id) {
        updateBody.registered_by_store_id = storeSession.store_id;
      }

      apiFetch('/api/consent/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateBody),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          updateBtn.classList.remove('is-loading');
          if (data.success) {
            lockNewlyChecked();
            hasComoPassport = true;
            // Show prominent "check your email" success state
            showEmailSentState(sectionExist, data.message || MSG.check_email, email);
          } else {
            showResult('error', data.error || MSG.update_err);
          }
        })
        .catch(function (err) {
          updateBtn.classList.remove('is-loading');
          console.error('[ConsentAPI] Update consent error:', err);
          showResult('error', MSG.update_err);
        });
    });
  }

  function showResult(type, message) {
    resultMsg.className = 'ca-result-msg is-' + type;
    resultText.textContent = message;
    void resultMsg.offsetWidth;
    resultMsg.classList.add('is-visible');
  }

  /* ------------------------------------------
     EMAIL SENT SUCCESS STATE
     Replaces section content with animated success overlay
     ------------------------------------------ */
  function showEmailSentState(container, message, email) {
    Array.from(container.children).forEach(function (child) {
      child.style.display = 'none';
    });

    var customerEmail = email || (emailInput ? emailInput.value.trim() : '');

    var el = document.createElement('div');
    el.className = 'ca-email-sent';
    el.style.textAlign = 'center';

    var titleText = LOCALE === 'it'
      ? 'Controlla l\'email del cliente: '
      : 'Check customer email: ';

    var backBtnLabel = LOCALE === 'it' ? 'Torna alla home' : 'Back to home';

    var html =
      '<div class="ca-email-sent__icon">' +
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">' +
          '<path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/>' +
        '</svg>' +
      '</div>' +
      '<h3 class="ca-email-sent__title">' + titleText +
        '<span style="color:#2563eb;">' + customerEmail + '</span>' +
      '</h3>' +
      '<p class="ca-email-sent__text">' + message + '</p>' +
      '<button type="button" class="ca-email-sent__btn" onclick="location.reload();">' + backBtnLabel + '</button>';

    el.innerHTML = html;
    container.appendChild(el);
    void el.offsetWidth;
    el.classList.add('is-visible');

    // Clear email field and scroll to top
    if (emailInput) emailInput.value = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ------------------------------------------
     COLLAPSIBLE CONSENT STATEMENTS
     ------------------------------------------ */
  document.querySelectorAll('[data-consent-box]').forEach(function (box) {
    var header = box.querySelector('.ca-consent-header');
    if (!header) return;
    header.addEventListener('click', function () {
      box.classList.toggle('is-open');
      header.setAttribute('aria-expanded', box.classList.contains('is-open'));
    });
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        header.click();
      }
    });
  });

  /* ------------------------------------------
     HANDLE SHOPIFY FORM ERRORS (page reload)
     ------------------------------------------ */
  var formErrorsEl = document.getElementById('ca-form-errors');
  if (formErrorsEl) {
    var savedEmail = formErrorsEl.getAttribute('data-email');
    if (savedEmail) {
      emailInput.value = savedEmail;
      onCustomerNotFound(savedEmail);
    }
  }

  /* ------------------------------------------
     INIT
     ------------------------------------------ */
  setupCheckboxes(document.getElementById('ca-new-required'));
  setupCheckboxes(document.getElementById('ca-exist-required'));
  setupCheckboxes(document.getElementById('ca-new-checkboxes'));
  setupCheckboxes(document.getElementById('ca-existing-checkboxes'));
  updateSubmitState();
})();
